import { networkWhitelist } from './util';

// utils/network.ts
export const checkNetworkSpeed = () => {
    const connection =
        (navigator as any).connection ||
        (navigator as any).mozConnection ||
        (navigator as any).webkitConnection;

    console.log('[Network] connection:', connection);

    if (connection && networkWhitelist()) {
        const { effectiveType, downlink } = connection;
        console.log(`[Network] 当前网络类型：${effectiveType}, 下行速度：${downlink}Mbps`);

        if (effectiveType === '2g' || effectiveType === 'slow-2g' || downlink < 0.5) {
            console.warn('[Network] 检测到慢速网络环境');
            alert(`[Network] 检测到慢速网络环境--下行速度：${downlink}Mbps`);
        }
    } else {
        console.log('[Network] 无法检测网络环境');
    }
};
